import { render, staticRenderFns } from "./ProductOption.vue?vue&type=template&id=5544fcf7&scoped=true&"
import script from "./ProductOption.vue?vue&type=script&lang=js&"
export * from "./ProductOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5544fcf7",
  null
  
)

export default component.exports